// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1_KY1","cls2":"CreateSocialItemModal-cls2_yaw CreateSocialItemModal-cls1_KY1"};